import { translate, translateFormatter, type RichTextFormatter } from '@/core/localization/translate';
export const {
  leonidasHelloText,
  leonidasLoginText
} = translate({
  "leonidasHelloText": "Hello",
  "leonidasLoginText": "Sign in"
});
export const leonidasMobileLoginText = translateFormatter<{
  br: RichTextFormatter;
}>([{
  "type": 0,
  "value": "Sign "
}, {
  "type": 8,
  "value": "br",
  "children": []
}, {
  "type": 0,
  "value": "in"
}], undefined, undefined, "en");